<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row >
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Retorno de Investimento
            </div>
          </v-col>
         <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <v-col xl="2" class="pt-1" v-if="nivelUsuarioApelido === 'M'">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  clearable
                  @click:clear="() => {
                    this.integrador = null
                    this.cliente = null
                    this.clientes = []
                    getClientes()
                  }"
                  clear-icon="close"
                  @change="() => {
                    this.integrador = null
                    this.cliente = null
                    this.clientes = []
                    getIntegradores(distribuidor)
                    getClientes()
                  }"
                ></v-autocomplete>
              </v-col>
              <v-col xl="2" class="pt-1" v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
                <v-autocomplete
                  :class="nivelUsuarioApelido !== 'D' ? 'ml-3' : ''"
                  :menu-props="{ offsetY: true}"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  clearable
                  @click:clear="() => {
                    this.cliente = null
                    this.clientes = []
                    getClientes()
                  }"
                  @change="() => {
                    this.cliente = null
                    this.clientes = []
                    getClientes()
                  }"
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col xl="2" class="pt-1">
                <v-autocomplete
                  :class="nivelUsuarioApelido !== 'I' ? 'ml-3' : ''"
                  :menu-props="{ offsetY: true}"
                  :items="clientes"
                  label="Cliente"
                  append-icon="expand_more"
                  v-model="cliente"
                  hide-details=""
                  :loading="loading || loadingClientes"
                  :disabled="loading || loadingClientes"
                  outlined
                  clearable
                  clear-icon="close"
                ></v-autocomplete>
              </v-col>
              <v-col xl="1" class="pt-1">
                <div class="ml-3 search_btn">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary" size="10">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados && dados.length > 0">
        <div class="impressao__header text-center">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Retorno de Investimento</p>
        </div>
        <div v-for="(distribuidor, indexDis) in dados" :key="indexDis" class="mb-3" v-show="distribuidor">
          <div class="text-h3 text-primary impressao__distribuidor">
            {{distribuidor.dis_nome}}
          </div>
          <div v-for="(integrador, indexInt) in distribuidor.integradores" :key="indexInt" class="mb-5" v-show="integrador">
            <div class="text-h7 text-primary mt-5 mb-2 impressao__integrador">
              Integrador {{integrador.int_nome}}
            </div>
            <v-simple-table class="base_table" v-if="integrador.usinas.length">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Cliente
                    </th>
                    <th class="text-center">
                      Usina
                    </th>
                    <th class="text-center">
                      Potência
                    </th>
                    <th class="text-center">
                      Investimento
                    </th>
                    <th class="text-center">
                      Geração MWh
                    </th>
                    <th class="text-center">
                      Produção R$
                    </th>
                    <th class="text-center">
                      Tempo
                    </th>
                    <th class="text-center">
                      ROI
                    </th>
                    <th class="text-center">
                      Payback
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in integrador.usinas" :key="index">
                    <td class="text-left">{{item.cliente ? item.cliente.cli_nome : 'Cliente excluído'}}</td>
                    <td class="text-center">{{item.usi_nome}}</td>
                    <td class="text-center">{{item.projeto ? item.projeto.usp_potencia : '0'}} kWp</td>
                    <td class="text-center">{{item.projeto ? $root.Formatter.floatToMoney(item.projeto.usp_total_investido) : $root.Formatter.floatToMoney(0)}}</td>
                    <td class="text-center">{{item.geracao}} MWh</td>
                    <td class="text-center">{{$root.Formatter.floatToMoney(item.producao)}}</td>
                    <td class="text-center">{{item.projeto ? item.projeto.tempo ? item.projeto.tempo : '-' : '-'}}</td>
                    <td class="text-center">{{item.roi}}%</td>
                    <td class="text-center">{{item.payback ? `${item.payback.replace(',0', '')} Meses` : '-'}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div v-else class="impressao__sem_dados">
              Nenhum dado encontrado.
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import Printd from 'printd'

export default {
  data () {
    return {
      user: null,
      search: '',
      loading: true,
      loadingSearch: false,
      integrador: null,
      integradores: [],
      loadingIntegradores: false,
      distribuidor: null,
      distribuidores: [],
      loadingDistribuidores: false,
      cliente: null,
      clientes: [],
      loadingClientes: false,
      nivelUsuarioApelido: '',
      datetime: new Date(),
      dados: [],
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ]
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000!important;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 15%;
            color: #000!important;
          }
          .impressao__footer {
            top : 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .impressao__distribuidor {
            font-size: 15px;
          }
          .impressao__integrador {
            font-size: 14px;
            padding-top: 2em;
            padding-bottom: 1em;
          }
          .impressao__sem_dados {
            font-size: 14px;
            padding-left: 15px;
          }
          .impressao__periodo {
            font-size: 12px!important;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table {
              width: 100%;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            .d-printer-none {
              display: none;
            }
            p {
              widows: 3;
            }

            // .impressao__footer {
            //   display: block;
            // }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 landscape !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    applyFilter () {
      this.loading = true
      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.integracao ? { interface: this.integracao } : '',
        this.cliente ? { cliente: this.cliente } : ''
      )
      this.$router.replace({name: 'RelatoriosRetornoInvestimento', query: query}).catch(() => {})

      this.loadFunctions()
    },
    loadFunctions () {
      let endpoint = '?filtro='
      if (this.distribuidor) {
        endpoint += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        endpoint += '&integrador=' + this.integrador
      }
      if (this.cliente) {
        endpoint += '&cliente=' + this.cliente
      }
      this.getDados(endpoint)
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.cliente) this.cliente = filters.cliente
      this.getDistribuidores()
      this.getIntegradores(this.distribuidor)
      this.getClientes()
      this.loadFunctions()
    },
    async getClientes () {
      this.loadingClientes = true
      let endpoint = 'clientes'

      if (this.integrador) {
        endpoint += `/integrador/${this.integrador}`
      } else if (this.distribuidor) {
        endpoint += `/distribuidor/${this.distribuidor}`
      }
      await Api.get(endpoint)
        .then(res => {
          let info = []
          res.data.map(item => {
            info.push({
              'text': item.cli_nome,
              'value': item.uuid_cli_id
            })
          })

          this.clientes = info
          this.loadingClientes = false
        })
        .catch(err => {
          this.loadingCliente = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          // this.cliente = null
          // this.clientes = []
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDados (endpoint) {
      this.loading = true
      await Api.get('relatorios/retorno' + endpoint)
        .then(res => {
          this.dados = res.data
          console.log('Relatórios retorno de investimento ==>', res.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do relatório!',
            color: 'error'
          })
          console.log(err)
        })
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__footer {
  bottom: 0;
  position: fixed;
  width: 100%;
  display: none;
}
.impressao__footer_text {
  color: #d0d0d0;
  font-size: 11px;
  padding-top: 5px;
}
.impressao__footer_hr {
  margin-bottom: 10px;
}
.impressao__header {
  width: 100%;
  display: none;
}
.usuario_modulos {
  width: 50%;
}
.theme--dark.v-data-table.integrador_boder {
  border-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/atendimento/RetornoInvestimento.vue